<app-notification></app-notification>
<app-confirmation></app-confirmation>
<app-loading></app-loading>

<div class="madar--v2">
    <mat-card class="floating-card bg-accent text-white" [class.floating-card--active]="!isNavigatorOnline">
        <mat-card-content>
            <mat-icon>wifi_off</mat-icon>
            <div class="small">{{'shared.Errors.NetworkError' | translate}}</div>
        </mat-card-content>
    </mat-card>
</div>
